module.exports = __webpack_public_path__ + "img/logo-placeholder.5ff1a11a.svg";